import styled from "styled-components";
import { Menu } from "antd";

export const SidebarMenu = styled(Menu) <{ inlineCollapsed: boolean }>`
	box-shadow: 0 3px 6px 0 rgba(167, 167, 167, 0.1);
	background-color: #000;
	height: 100vh;
	text-align: center;
	font-size: 19px;
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: "Roboto" !important;
	font-weight: 600;
	padding-top: 50px;

	.nav-link {
		font-family: "Roboto" !important;
		font-weight: 500 !important;
	}

	.nav-header.active {
		color: #ed1c24 !important;
	}

	.nav-header {
		color: #fff !important;
	}

	.nav-link.active {
		font-weight: 900 !important;
		color: #ed1c24 !important;
	}

	.disabled-header {
		color: #2e333e !important;
		pointer-events: none;
	}

	.disabled-link {
		font-family: "Roboto" !important;
		font-weight: 500 !important;
		pointer-events: none;
	}

	.ant-menu-submenu-title {
		padding: 0 !important;
		margin: 0 !important;
	}

	.ant-menu-submenu,
	.ant-menu-item {
		padding: 5px 5px 5px 9px !important;
		margin: 0 0 16px !important;
		color: #fff;
		margin-bottom: 16px;
		line-height: 1.38;
		letter-spacing: normal;
		text-align: left;
		width: 100%;
	}

	.ant-menu-sub {
		background-color: transparent !important;
		font-size: 16px;
	}

	.ant-menu-item:first {
		margin-top: 16px !important;
	}

	.ant-menu-item {
		height: 52px;
	}

	.ant-menu-item.ant-menu-item-only-child {
		padding: 4px 0 4px 50px !important;
		margin-bottom: 16px;
		height: 16px;
	}

	.ant-menu-inline {
		margin-top: 8px;
	}

	.ant-menu-submenu-title svg {
		color: #fff;
	}

	.ant-menu-item-selected {
		color: #2e333e;
		background-color: transparent !important;
	}

	.ant-menu-title-content {
		color: #fff;
	}

	.ant-menu-submenu-selected > .ant-menu-submenu-title {
		color: #4299e1;
	}

	.ant-menu-item:hover,
	.ant-menu-submenu:hover {
		background-color: transparent !important;
	}

	.ant-menu-item-icon {
		background-color: #000 !important;	
		color: #fff !important;
	}

	.ant-menu-item-icon.active {
		color: #ed1c24 !important;
	}

	.anticon svg {
		font-size: 18px !important;
	}
`;

export const SidebarImage = styled.div`
	padding: 8px;
	background-color: #e0effd;
	border-radius: 8px;
`;


export const SidebarContainer = styled.div<{ collapsed: boolean }>`
	width: ${({ collapsed }) => (collapsed ? "80px" : "260px")};
	transition: width 0.2s;
	position: fixed; 
	left: 0; 
	top: 64px;
	bottom: 0;
	display: flex;
	flex-direction: column;
`;
